import { useQuery } from '@apollo/client';

import { MY_COMPANY_INVITATIONS_QUERY } from '../graphql/queries';

/**
 * The pending company invitations addressed to the signed-in user's own verified email (Invitation
 * Discovery). Always resolved server-side from the caller's identity — there is no email argument,
 * so a user only ever sees invitations sent to themselves. `cache-and-network` keeps the discovery
 * surfaces (onboarding card, /account/invitations) fresh after an accept/decline without a manual
 * refetch, while still rendering instantly from cache.
 */
export function useMyInvitations() {
  const { data, loading, error, refetch } = useQuery(MY_COMPANY_INVITATIONS_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const invitations = data?.myCompanyInvitations ?? [];

  return {
    invitations,
    hasInvitations: invitations.length > 0,
    loading: loading && !data,
    error: error ?? null,
    refetch,
  };
}
